import type { TranslationTag } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import styles from './TotalRow.scss';

interface Props {
  name: string;
  translationTag: TranslationTag;
  value: React.ReactElement | number;
  className?: string;
  dollarValue?: boolean;
}

export const TotalRow = ({ name, translationTag, value, className, dollarValue }: Props) => (
  <li className={className}>
    <label htmlFor={`bet-slip-footer-${name}`} className={styles.description}>
      <Translation {...translationTag} />
    </label>
    <output className={styles.value} id={`bet-slip-footer-${name}`} aria-live="off">
      {typeof value === 'number' ? (
        <CurrencyAmount value={value} dollarValue={dollarValue} />
      ) : (
        value
      )}
    </output>
  </li>
);
